(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dn-booster-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dn-booster-stories')) {
    customElements.define('dn-booster-stories', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        const video = dialog.querySelector('video');
        this.querySelectorAll('[data-story-src]').forEach((button) => {
          button.addEventListener('click', () => {
            video.poster = button.dataset.storyPoster;
            video.src = button.dataset.storySrc;
            dialog.showModal();
            video.play().catch(() => {});
          });
        });
        this.querySelector('.dn-booster-stories__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => {
          video.pause();
          video.removeAttribute('src');
          video.load();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dn-cart-offer-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__dnCartOfferGuard) return;
  window.__dnCartOfferGuard = true;
  const packIds = new Set([47736792383812, 47736792416580]);
  const giftId = 53787554185540;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let syncing = false;
  let rerun = false;
  let timer;
  let subscriptionsBound = false;
  let cartCouldNeedSync = Number(document.getElementById('dn-gift-feedback')?.dataset.cartItems || 0) > 0;
  const request = async (path, options = {}) => {
    const response = await nativeFetch(`${root}${path}`, {
      credentials: 'same-origin', ...options,
      headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) }
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };
  const showError = (value) => {
    const feedback = document.getElementById('dn-gift-feedback');
    if (feedback) feedback.hidden = !value;
  };
  const getGiftAction = (cart) => {
    const hasPack = cart.items.some((item) => packIds.has(Number(item.variant_id)) && item.quantity > 0);
    const gifts = cart.items.filter((item) => Number(item.variant_id) === giftId);
    const owned = gifts.filter((item) => item.properties?._dn_pack_gift === '1');
    const otherReward = gifts.some((item) => item.properties?._dn_pack_gift !== '1');
    const preserveThresholdReward = cart.currency === 'EUR' && cart.total_price >= 10000;
    if (hasPack && gifts.length === 0) return { add: true };
    const updates = {};
    owned.forEach((item, index) => {
      const quantity = !otherReward && index === 0 && (hasPack || preserveThresholdReward) ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return Object.keys(updates).length ? { updates } : null;
  };
  const alignDiscountMessage = () => {
    document.querySelectorAll('#upCart .announcement_product_cart').forEach((element) => {
      const current = element.textContent || '';
      const updated = current.replace(/-10\s*%/gi, '-15 %');
      if (updated !== current) element.textContent = updated;
    });
  };
  const syncGift = async () => {
    if (syncing) { rerun = true; return; }
    syncing = true;
    try {
      const cart = await request('cart.js');
      cartCouldNeedSync = cart.items.length > 0;
      const action = getGiftAction(cart);
      if (action?.add) {
        await request('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: giftId, quantity: 1, properties: { _dn_pack_gift: '1' } }] }) });
      } else if (action?.updates) {
        await request('cart/update.js', { method: 'POST', body: JSON.stringify({ updates: action.updates }) });
      }
      showError(false);
      if (action && typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
      alignDiscountMessage();
    } catch {
      showError(true);
    } finally {
      syncing = false;
      if (rerun) { rerun = false; queueSync(); }
    }
  };
  const queueSync = () => {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 250);
  };
  const bindSubscriptions = () => {
    if (subscriptionsBound || typeof window.upcartSubscribeCartUpdated !== 'function') return subscriptionsBound;
    subscriptionsBound = true;
    window.upcartSubscribeCartUpdated(() => { cartCouldNeedSync = true; alignDiscountMessage(); queueSync(); });
    if (typeof window.upcartSubscribeCartLoaded === 'function') window.upcartSubscribeCartLoaded(() => { alignDiscountMessage(); if (cartCouldNeedSync) queueSync(); });
    return true;
  };
  const start = () => {
    if (cartCouldNeedSync) queueSync();
    let attempts = 0;
    const bind = () => {
      alignDiscountMessage();
      if (!bindSubscriptions() && ++attempts < 20) setTimeout(bind, 500);
    };
    bind();
    const watchCart = () => {
      const cart = document.getElementById('upCart');
      if (!cart) return false;
      new MutationObserver(alignDiscountMessage).observe(cart, { childList: true, subtree: true });
      alignDiscountMessage();
      return true;
    };
    if (!watchCart()) {
      const observer = new MutationObserver(() => { if (watchCart()) observer.disconnect(); });
      observer.observe(document.body, { childList: true });
      setTimeout(() => observer.disconnect(), 15000);
    }
  };
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    try {
      const input = args[0];
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      if (response.ok && url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) { cartCouldNeedSync = true; queueSync(); }
    } catch {}
    return response;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dn-design-system"] && !Shopify.designMode) return;
  try {
    const hidePrivateCartProperties = (root) => {
    if (!(root instanceof Element)) return;
    const rows = root.matches('.upcart-item-property') ? [root] : Array.from(root.querySelectorAll('.upcart-item-property'));
    rows.forEach(row => {
      if (row.querySelector('strong')?.textContent.trim().startsWith('_')) {
        row.dataset.dnPrivate = 'true';
        row.hidden = true;
      }
    });
  };
  const bindPrivateCartObserver = () => {
    const cart = document.getElementById('upCart');
    if (!cart || cart.dataset.dnPrivateObserver === 'true') return Boolean(cart);
    cart.dataset.dnPrivateObserver = 'true';
    hidePrivateCartProperties(cart);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        hidePrivateCartProperties(node);
        const row = node.closest('.upcart-item-property');
        if (row) hidePrivateCartProperties(row);
      }));
    }).observe(cart, { childList: true, subtree: true });
    return true;
  };
  if (!bindPrivateCartObserver()) {
    const cartMountObserver = new MutationObserver(() => {
      if (bindPrivateCartObserver()) cartMountObserver.disconnect();
    });
    cartMountObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => cartMountObserver.disconnect(), 15000);
  }

  const replaceFeraHeadings = (root = document) => {
    const selector = '.fera-widget h1[data-fera-widget-heading]';
    const headings = [];
    if (root instanceof Element && root.matches(selector)) headings.push(root);
    if ('querySelectorAll' in root) headings.push(...root.querySelectorAll(selector));
    headings.forEach(heading => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
    return headings.length > 0;
  };
  if (!replaceFeraHeadings()) {
    const feraHeadingObserver = new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node instanceof Element && replaceFeraHeadings(node)))) feraHeadingObserver.disconnect();
    });
    feraHeadingObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => feraHeadingObserver.disconnect(), 15000);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dn-product-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dn-product-shortcuts')) {
    customElements.define('dn-product-shortcuts', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        this.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('[data-dn-open-details]');
          if (!link || !this.contains(link)) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!(target instanceof HTMLDetailsElement)) return;
          event.preventDefault();
          event.stopPropagation();
          target.open = true;
          target.querySelector('summary')?.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  if (!customElements.get('dn-offer-copy')) {
    customElements.define('dn-offer-copy', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        const button = this.querySelector('[data-dn-copy-code]');
        if (!button || !navigator.clipboard?.writeText) return;
        this.abortController = new AbortController();
        button.hidden = false;
        button.addEventListener('click', async () => {
          const status = this.querySelector('[role="status"]');
          try {
            await navigator.clipboard.writeText(button.dataset.dnCopyCode);
            if (!this.isConnected) return;
            button.textContent = button.dataset.copiedLabel;
            status.textContent = button.dataset.success;
          } catch {
            if (this.isConnected) status.textContent = button.dataset.error;
          }
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
